// extracted by mini-css-extract-plugin
module.exports = {"optOutWarning":"ManualReload_optOutWarning__Pm4-E","optOutWarningIcon":"ManualReload_optOutWarningIcon__PVAsp"};